<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div v-show="!showSkeleton">
      <div class="text-h4 mb-2">Manutenção de Operadores</div>

      <v-data-iterator
        :no-data-text="noDataText"
        :items="dataOperadores"
        :items-per-page.sync="itemsPerPage"
        :page="page"
        :search="search"
        :no-results-text="noResultsText"
        hide-default-footer
      >
        <template v-slot:header>
          <v-row>
            <v-col cols="7" class="mr-2">
              <v-btn dark color="orangePcm" @click="gerarListaOperadores" class="mr-2 my-2">
                Atualizar Lista
              </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="4" class="mr-2">
              <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:default="props">
          <v-data-table
            dense
            :headers="headers"
            :items="props.items"
            hide-default-footer
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.botoes`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="logoutOperador(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                    <v-icon>mdi-account-remove</v-icon>
                  </v-btn>
                </template>
                <span>Logout Operador</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <div class="ml-4 mb-2 grey--text">
              <p>Total de Operadores: {{ qtdOperadores }}</p>
            </div>
            <v-spacer />
            <div class="pb-5">
              <ListPagination
                :page="page"
                :numberOfPages="numberOfPages"
                @firstPage="firstPage"
                @formerPage="formerPage"
                @nextPage="nextPage"
                @lastPage="lastPage"
              />
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import gerencialmentoOperadoresStore from '../_store'
import operadoresHttpService from '../_services/operadoresHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    dataOperadores: [],
    headers: [
      {
        text: 'Operador',
        value: 'agente',
        align: 'left',
      },
      {
        text: 'Código',
        value: 'numero',
        align: 'left',
      },
      {
        text: 'Status',
        value: 'status',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ramal Logado',
        value: 'ramal',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapGetters('gerenciamentoOperadoresModuleCallCenterStore', ['getOperadores']),
    numberOfPages() {
      return Math.ceil(this.dataOperadores.length / this.itemsPerPage)
    },
    qtdOperadores() {
      return this.dataOperadores.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'gerenciamentoOperadoresModuleCallCenterStore', gerencialmentoOperadoresStore)
    await this.gerarListaOperadores()
  },

  methods: {
    ...mapActions('gerenciamentoOperadoresModuleCallCenterStore', ['listarOperadoresLogadosNoBanco']),

    async gerarListaOperadores() {
      this.showSkeleton = true

      this.dataOperadores.splice(0)
      await this.listarOperadoresLogadosNoBanco()

      this.dataOperadores = this.getOperadores.filter(
        operador => operador.status === 'logado' || operador.status === 'pausado'
      )

      this.showSkeleton = false
    },

    async logoutOperador(operador) {
      let resultado = window.confirm(`Deseja realizar o logout do operador "${operador.agente}"?`)
      if (resultado) {
        if (operador.status === 'logado' || operador.status === 'pausado') {
          await operadoresHttpService.logoutForcadoOperador({ numeroOperador: operador.numero })
        }
        await this.gerarListaOperadores()
      }
    },
  },
}
</script>
